import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const SocialProfilesBasicInfoComponent = ({ handleInnerFormChange, selectedSocialProfiles, socialProfileType }: any) => (
    <>
        <AccordionContainer
            child={
                <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>

                    <InputContainer
                        label="SocialProfile Type"
                        labelField="Text"
                        list={socialProfileType}
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'SocialProfileTypeId'
                            )
                        }}
                        optionName='Choose SocialProfile Type'
                        type="select"
                        value={selectedSocialProfiles?.SocialProfileTypeId}
                        valueField="Value"
                    />

                    <InputContainer
                        label="Name"
                        name="Name"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'Name'
                            )
                        }}
                        type="text"
                        value={selectedSocialProfiles?.Name}
                    />

                    <InputContainer
                        label="SocialProfile Url"
                        name="SocialProfileUrl"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'SocialProfileUrl'
                            )
                        }}

                        type="text"
                        value={selectedSocialProfiles?.SocialProfileUrl}
                    />

                    <InputContainer
                        label="Description"
                        name="Description"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'Description'
                            )
                        }}
                        type="text"
                        value={selectedSocialProfiles?.Description}
                    />
                </div>
            }
            expandedPanel="basicInfo"
            headerTitle="Basic Info"
        />
    </>
)
export default SocialProfilesBasicInfoComponent;
